module.exports = __webpack_public_path__ + "static/media/giai-ma.443d2b54.jpeg";